import { useEffect, useRef } from 'react'
import { useMonaco } from '@monaco-editor/react'

/**
 * prefix 로 시작하는 Monaco 모델을 정리하는 훅.
 * prefix 가 바뀔 때와 언마운트될 때 이전 prefix 의 모델을 모두 dispose 한다.
 *
 * 왜 필요한가 — @monaco-editor/react 는 언마운트 시 "그 순간 붙어있던" 모델 하나만
 * dispose 한다(keepCurrentModel=false 기본). 탭마다 path 를 나눠 쓰면 비활성 탭의
 * 모델이 살아남고, 다음 마운트에서 같은 path 로 재사용되면서 낡은 내용이 그대로
 * 표시된다 — 마운트 직후의 value 동기화 effect 는 첫 실행을 건너뛰므로 교정되지 않아
 * 화면 내용과 React 상태가 어긋난다.
 */
export function useMonacoModelCleanup(prefix: string) {
  const monaco = useMonaco()
  // monaco 로딩 완료가 정리 effect 를 재실행시키지 않도록 ref 로만 참조한다
  const monacoRef = useRef(monaco)
  monacoRef.current = monaco

  useEffect(() => {
    return () => {
      const m = monacoRef.current
      if (!m) return
      for (const model of m.editor.getModels()) {
        if (model.isDisposed()) continue
        // Uri.parse('a/b.css') 는 scheme 이 file 로 채워지며 path 앞에 '/' 가 붙는다
        if (model.uri.path.replace(/^\//, '').startsWith(prefix)) model.dispose()
      }
    }
  }, [prefix])
}
